<script>
import API from '@/api/Comment'
import Comments from '@/components/Comment/List'

export default {
  props: {
    lead: String,
  },
  watch: {
    lead: {
      handler: 'fetch',
      immediate: true,
    },
  },
  data() {
    return {
      promises: {
        comment: null,
        fetch: null,
      },
      comments: [],
    }
  },
  methods: {
    fetch() {
      this.promises.fetch = API.get({ id: this.lead }, { query: 'LeadComments' }).then(comments => {
        this.comments = comments
      })
    },
    comment(data) {
      this.promises.comment = API.mutate({
        reference: { onModel: 'Lead', ref: this.lead },
        ...data,
      }).then(data => {
        this.comments.push(data)
        this.$emit('create', data)
        this.$emit('processed', data, true)
      })
    },
  },
  components: {
    Comments,
  },
}
</script>

<template>
  <Loader :value="promises.fetch">
    <Comments :value="comments" @submit="comment" :promise="promises.comment" v-on="$listeners" />
  </Loader>
</template>
